<template>
  <div class="loss-reasons-pie-chart">
    <div class="filters">
      <label>Ano:</label>
      <select
        v-model="selectedYear"
        class="filter-select"
        @change="fetchChartData"
      >
        <option
          v-for="year in availableYears"
          :key="year"
          :value="year"
        >
          {{ year }}
        </option>
      </select>

      <label>Mês:</label>
      <select
        v-model="selectedMonth"
        class="filter-select"
        @change="fetchChartData"
      >
        <option value="">
          Todos
        </option>
        <option
          v-for="month in monthOptions"
          :key="month.value"
          :value="month.value"
        >
          {{ month.label }}
        </option>
      </select>

      <label>Estado:</label>
      <select
        v-model="selectedState"
        class="filter-select"
        @change="fetchChartData"
      >
        <option value="">
          Todos
        </option>
        <option
          v-for="state in estados"
          :key="state"
          :value="state"
        >
          {{ state }}
        </option>
      </select>

      <label>Tipo de Licitação:</label>
      <select
        v-model="selectedBiddingType"
        class="filter-select"
        @change="fetchChartData"
      >
        <option value="">
          Todos
        </option>
        <option
          v-for="type in biddingTypes"
          :key="type"
          :value="type"
        >
          {{ type }}
        </option>
      </select>
    </div>

    <div class="chart-box">
      <loss-reasons-pie-chart-base
        v-if="chartData"
        :key="selectedYear + selectedMonth + selectedState + selectedBiddingType"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import filterBiddingLossReasonsData from '@/syslic/dashboard/lossReasons/filterBiddingLossReasonsData'
import fetchReportData from '@/syslic/dashboard/reportService'

const LossReasonsPieChartBase = {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData(newData) {
      this.renderChart(newData, this.options)
    },
  },
}

export default {
  name: 'LossReasonsPieChart',
  components: {
    LossReasonsPieChartBase,
  },
  data() {
    return {
      allData: [],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
          title: { display: true, text: 'Motivos de Perda - Licitações' },
        },
      },
      selectedYear: new Date().getFullYear(),
      selectedMonth: '',
      selectedState: '',
      selectedBiddingType: '',
      estados: [],
      biddingTypes: [],
      availableYears: [],
      monthOptions: [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' },
      ],
    }
  },
  async mounted() {
    this.allData = await fetchReportData()
    this.populateFilters()
    this.fetchChartData()
  },
  methods: {
    populateFilters() {
      const statesSet = new Set()
      const typesSet = new Set()
      const yearsSet = new Set()

      this.allData.forEach(item => {
        if (item.stateName) statesSet.add(item.stateName)
        if (item.biddingType) typesSet.add(item.biddingType)
        if (item.date) yearsSet.add(new Date(item.date).getFullYear())
      })

      this.estados = Array.from(statesSet).sort()
      this.biddingTypes = Array.from(typesSet).sort()
      const currentYear = new Date().getFullYear()
      this.availableYears = Array.from(yearsSet)
        .filter(year => year <= currentYear)
        .sort((a, b) => b - a)
    },
    fetchChartData() {
      const filters = {
        year: this.selectedYear,
        month: this.selectedMonth,
        stateSelecionado: this.selectedState,
        biddingTypeSelecionado: this.selectedBiddingType,
      }
      this.chartData = filterBiddingLossReasonsData(this.allData, filters)
    },
  },
}
</script>

<style scoped>
.loss-reasons-pie-chart {
  padding: 1rem;
}
.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  max-width: 150px;
  width: 100%;
}
.chart-box {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 320px) {
  .chart-box {
    height: 350px;
    transform: scale(0.6);
  }
}
@media (max-width: 375px) {
  .chart-box {
    height: 400px;
    transform: scale(0.7);
  }
}
@media (max-width: 425px) {
  .chart-box {
    height: 400px;
    transform: scale(0.8);
  }
}
</style>
